import ReactGA from 'react-ga4';

export const sendPageviewToGa4 = (title: string) => {
  const { pathname, search, hostname } = window.location;

  ReactGA.send({
    hitType: 'pageview',
    host: hostname,
    path: pathname + search,
    name: title,
  });
};
